// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"1323": "a7ce5c0e4430","5240": "1beb361b70a1","5372": "87c2d5f83ecd","5395": "b9049a98ba70","8607": "9b0de4182652",}[chunkId] + ".css"
}